<template>
  <div class='h100' ref='echartsBar'></div>
</template>

<script>
import echarts from 'echarts';
import Vue from 'vue';

Vue.prototype.$echarts = echarts;
export default {
  name: 'EchartsBar',
  props: [
    'element',
  ],
  data() {
    return {
      chart: null, // 图表
      title: this.element.title,
      unit: this.element.unit,
      legendData: this.element.legendData,
      xAxisData: this.element.xAxisData,
      seriesData: [],
    };
  },
  mounted() {
    let $this = this;
    $this.loadEchart();
    window.addEventListener('resize', () => {
      $this.chart.resize();
    });
  },
  methods: {
    loadEchart() {
      this.chart = this.$echarts.init(this.$refs.echartsBar);
    },
    initChart() {
      let $this = this;
      const series = [];
      if ((typeof $this.seriesData[0]) == 'object') {//数据格式:[[],[]]
        this.legendData.forEach((value,key) => {
          series.push({
            name: value,
            type: 'bar',
            data: $this.seriesData[key],
            markPoint: {
              data: [
                {type: 'max', name: '最大值'},
                {type: 'min', name: '最小值'}
              ]
            },
            markLine: {//系列中的数据标线内容
              symbol:"none",
              data: [
                {
                  silent:true,
                  type: 'average',
                  name: '平均值',
                }
              ]
            }
          })
        })
      } else {//数据格式:[]
        series.push({
          name: null,
          type: 'bar',
          data: $this.seriesData,
          markPoint: {
            data: [
              {type: 'max', name: '最大值'},
              {type: 'min', name: '最小值'}
            ]
          },
          markLine: {//系列中的数据标线内容
            // symbol:['arrow', 'none'],
            symbol:'none',
            itemStyle: {
              normal: {
                label: {
                  formatter: '{c}({b})'
                }
              }
            },
            data: [
              {
                silent:true,
                type: 'average',
                name: '平均值'
              }
            ]
          }
        })
      }
      $this.chart.setOption({
        title: {
          text: $this.title,
          // subtext: '纯属虚构',
          top: 1,
          left: 1,
          textStyle: {
            color: '#ccc'
          }
        },
        tooltip: {
          trigger: 'axis'
        },
        // legend: {
        //   data: ['蒸发量', '降水量']
        // },
        legend: $this.legendData,
        toolbox: {
          show: true,
          left:'right',
          feature: {
            // dataView: {show: true, readOnly: false},
            dataView : {
              show: true,
              title: '数据视图',
              readOnly: true,
              optionToContent: function (opt) {
                let axisData = opt.xAxis[0].data; //坐标数据
                let series = opt.series; //折线图数据
                let tdHeads = ''; //表头
                let tdBodys = ''; //数据
                if ((typeof $this.seriesData[0]) == 'object') {//数据格式:[[],[]]
                  series.forEach(function (item) {
                    //组装表头
                    tdHeads += `<td style="padding: 0 10px">${item.name}</td>`;
                  });
                  let table = `<table border="1" style="margin:auto;border-collapse:collapse;font-size:14px;text-align:center"><tbody><tr>${tdHeads} </tr>`;
                  for (let i = 0, l = axisData.length; i < l; i++) {
                    for (let j = 0; j < series.length; j++) {
                      //组装表数据
                      tdBodys += `<td>${ series[j].data[i]}</td>`;
                    }
                    table += `<tr><td style="padding: 0 10px">${axisData[i]}</td>${tdBodys}</tr>`;
                    tdBodys = '';
                  }
                  table += '</tbody></table>';
                  return table;
                } else {//数据格式:[]
                  axisData.forEach((value,key) => {
                    //组装表头
                    tdHeads += `<td style="padding: 0 10px">${value}</td>`;
                    //组装表数据
                    tdBodys += `<td style="padding: 0 10px">${series[0].data[key]}</td>`;
                  });
                  let table = `<table border="1" style="margin:auto;border-collapse:collapse;font-size:14px;text-align:center">
                                <tbody>
                                    <tr>${tdHeads}</tr>
                                    <tr>${tdBodys}</tr>
                                </tbody>
                              </table>`;
                  return table;
                }

              }
            },
            magicType: {show: true, type: ['line', 'bar']},
            dataZoom: {show: false, readOnly: false}, //区域缩放
            restore: {show: false},
            saveAsImage: {show: true}
          }
        },
        calculable: false,
        xAxis: [
          {
            type: 'category',
            axisLabel: {
              interval:0,//代表显示所有x轴标签显示
              // rotate:90, //代表逆时针旋转45度
              formatter: function (value) {
                let newName = "";
                const nameLength = value.length;
                const number = 5;  //一行显示几个字
                const rowNumber = Math.ceil(nameLength / number);
                if (nameLength > number) {
                  for (let i = 0; i < rowNumber; i++) {
                    let str = "";
                    const start = i * number;
                    const end = start + number;
                    if (i == rowNumber - 1) {
                      str = value.substring(start, nameLength);
                    } else {
                      str = value.substring(start, end) + "\n";
                    }
                    newName += str;
                  }

                } else {
                  newName = value;
                }
                return newName
              },
            },
            // data: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月']
            data: $this.xAxisData
          }
        ],
        yAxis: [
          {
            type: 'value',
            // name:'单位(S)',
            axisLabel: {
              formatter: `{value} ${$this.unit}`
            }
          }
        ],
        series: series
      });
    },
    setDatas(params) {
      this.seriesData = params;
      console.log('element.seriesData',this.seriesData);
      this.initChart();
    }
  }
};

</script>

<style scoped>

</style>
